import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { TeamSection } from "@/components/TeamSection";
import { GetPaidSection } from "@/components/GetPaidSection";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { FeaturedProduct } from "@/components/FeaturedProduct";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyBlueShuck } from "@/components/WhyBlueShuck";
import { Pricing } from "@/components/Pricing";
import { ManagedWebsites } from "@/components/ManagedWebsites";
import { ClosingCTA } from "@/components/ClosingCTA";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";
import { setSeo } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    setSeo({
      title: "Blue Shuck Consulting LTD | Construction Software for SMEs",
      description:
        "Blue Shuck Consulting LTD builds practical software products for construction SMEs, including Trade Off, with bespoke development available for specialist business needs.",
    });
  }, []);

  return (
    <div className="App bg-white">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <TeamSection />
        <GetPaidSection />
        <Services />
        <About />
        <FeaturedProduct />
        <HowItWorks />
        <WhyBlueShuck />
        <Pricing />
        <ManagedWebsites />
        <ClosingCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
